import { CONFIG_TRAINING_NOTIFICATION } from '../actions/actionTypes';

const initialState = {
    configTrainingNotification: {
        impactEvaluationStatus: false,
        trainingTitle: '',
        daysToComplete: 0,
        availableAfterDays: 0,
        customData: null,
    },
};

export const configTrainingNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONFIG_TRAINING_NOTIFICATION:
            return {
                configTrainingNotification: {
                    ...initialState.configTrainingNotification,
                    ...action.configTrainingNotification,
                },
            };
        default:
            return state;
    }
};
